import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PatchObject } from '@store/models';
import { AuthDispatchers, AuthSelectors } from '../../auth/store/services';

@Component({
    selector: 'app-uniconta-settings',
    templateUrl: './uniconta-settings.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UnicontaSettingsComponent {
    officeSettings$ = this.authSelectors.officeSettings$;

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private authSelectors: AuthSelectors,
        private authDispatch: AuthDispatchers
    ) { }

    onDismiss() {
        this.ngbActiveModal.dismiss();
    }

    updateSetting(currentValue: any, event: Event, path: string) {
        const target: HTMLInputElement = event.target as HTMLInputElement;
        const newValue = target.value;
        if (newValue.toString() === currentValue?.toString()) { return; }
        const patchObject: PatchObject = {value: newValue, path, op: 'replace'};
        this.authDispatch.updateOfficeSetting(patchObject);
    }
}
